import { serverBus } from '@/main'
import Global from '@/scripts/Global'
import SessionManager from '@/Manager/Session.manager'
import LicenseApi from '@/scripts/api/license.api';
import ChannelNotification from '@/Manager/Notification/Channel.manager';
import VueSignals from '@/scripts/VueSignals';

export default {
    name: 'AssignLicense',
    data (){
        return {          
          showModal: false,          
          mainSpinner: false,          
          overlayType : Global.getGlobalSessionValue(VueSignals.OVERLAY_TYPE),      
          Licenses: Array,          
        }
      },      
    mounted() {
  
     serverBus.$on(VueSignals.OVERLAY_TYPE, (overlayType) => {
      this.overlayType = overlayType
     })
     
     serverBus.$on(VueSignals.SHOW_MODAL, (showModal) => {
      this.showModal = showModal
     })

     LicenseApi.List().then(res => {
        if(res.data.result){
            this.Licenses = res.data.licenses
        }
     })
         
    },
  methods: {    
    closeModal(){
      this.showModal = false;
    },
    modalCall(){
      this.showModal = true;
    },     
    AssignLicence(cust_order_cp_id){
        LicenseApi.Assign(SessionManager.getActiveChannelId(),cust_order_cp_id).then(res => {
            if(res.data.result){
                let licenseToAssign = this.Licenses.find(currLicense => {return currLicense.cust_order_cp_id == cust_order_cp_id})
                ChannelNotification.AssignLicense(SessionManager.getActiveChannelId(), 
                                                licenseToAssign, 
                                                SessionManager.getActiveChannel().user_ids)
                Global.globalValue(VueSignals.SHOW_MODAL, false)    
            }
        })
    }
  }
}
